import { render, staticRenderFns } from "./Dataview.vue?vue&type=template&id=61d9d3fe&scoped=true"
import script from "./Dataview.vue?vue&type=script&lang=js"
export * from "./Dataview.vue?vue&type=script&lang=js"
import style0 from "./Dataview.vue?vue&type=style&index=0&id=61d9d3fe&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61d9d3fe",
  null
  
)

export default component.exports